<template>
    <confirmation-dialog
        ref="modal"
        label="Uitschrijven"
        description="Weet je zeker dat je deze contactpersoon wil uitschrijven voor alle huidige en toekomstige e-mails?"
    >
        <template #actions>
            <flex-container align-items="center" justify-content="flex-end">
                <button-text @click="emit('cancel')">
                    Nee
                </button-text>
                <button-block without-loading @click="emit('confirm')">
                    Ja
                </button-block>
            </flex-container>
        </template>
    </confirmation-dialog>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import type { ExposedOverlay } from '@keyvue/one-ui';

    const props = defineProps<{ visible: boolean }>();
    const emit = defineEmits<{
        (e: 'cancel'): void;
        (e: 'confirm'): void;
    }>();

    const modal = ref<ExposedOverlay>();
    watch(() => props.visible, (value) => {
        if (value) {
            modal.value?.openOverlay();
        } else {
            modal.value?.closeOverlay();
        }
    });
</script>
